// extracted by mini-css-extract-plugin
export default {"titlePage":"roleDefault_titlePage__6fy3t"};